<template>
    <div class="search-wrap" v-if="is_show">
        <div class="inner">
            <div class="search-input">
                <span class="ico">⌕</span>
                <input type="text" placeholder="Search" @input="input" @enter="search" ref="input" />
                <span @click="is_show = false"> ⒳ </span>
            </div>

            <header class="search-header">
                <div class="top">
                    <span>{{count}} results</span>
                    <router-link @click.native="is_show = false" to="/">Home</router-link>
                </div>
                <!-- <ul>
                    <li v-for="(list, index) in results" :key="list.key + '1_2' + index" :class="['type-' + list.key]"  v-if="list.items.length !== 0" class="search-item">
                        <span class="search-link" @click="scrollTo(index)">{{list.title}}</span>
                    </li>
                </ul> -->
            </header>

            <div class="search-box" ref="search">
                <Loading v-if="is_loading" class="static" />
                <div v-for="(item, index) in results" :key="index"  @click="close" class="item">
                    <Link :post_link="item.link" v-html="item.post_title"></Link>
                </div>

                <!-- <div v-for="(list, index) in results" :key="list.key + '_' + index" :id="'js-search-list-' + index">
                    <dl :class="['type-' + list.key]" class="list-item" v-if="list.items.length !== 0">
                        <dt>{{list.title}}</dt>
                        <dd v-for="item in list.items" :key="item.ID" @click="is_show = false">
                            <router-link :to="list.slug + item.post_name">{{item.post_title}}</router-link>
                        </dd>
                    </dl>
                </div> -->
            </div>
        </div>


    </div>
</template>

<script>
// import '@/assets/svg/search.svg?sprite';

import { EventBus } from '@/events/bus.js';
import Link from '@/components/ui/Link.vue';
import Loading from '@/components/Loading.vue';
import debounce from 'lodash/debounce';

export default {
    name: 'site-search',

    data() {
        return {
            is_show: false,
            is_loading: false,
            count: 0,
            results: [],
        }
    },


    components: {
        Loading,
        Link,
    },

    
    methods: {
        scrollTo(index) {
            let offset = window.innerWidth/7.1;
            this.$smoothScroll({
                container: this.$refs.search,
                offset: ~offset,
                scrollTo: document.querySelector('#js-search-list-' + index),
                duration: 300,
            });
        },


        input: debounce(function () {
            this.search();
        }, 500),

        search() {
            let val = this.$refs.input.value;

            if (!this.is_loading && val !== '') {
                this.is_loading = true;
                this.results = [];
                this.count = 0;

                this.$ajax.get('/search/?key_word=' + val).then(res => {
                    this.is_loading = false;

                    for (const [key, items] of Object.entries(res.data)) {


                        if (items) {
                            items.forEach(item => {
                                this.results.push(item);
                            });

                            
                            this.count = this.count + items.length;
                        }


                    }
                });


            }
        },

        show() {
            this.is_show = true;
            document.body.classList.add('hide-scrollbar');
            
            setTimeout(() => {
                this.$refs.input.value = '';
                this.$refs.input.focus();
            }, 1);
        },

        close() {
            this.is_show = false;
            document.body.classList.remove('hide-scrollbar');
        },
    },

    mounted() {
        EventBus.$off('search.open');
        EventBus.$on('search.open', (obj) => {
            this.show();

            if (obj.keyword) {
                setTimeout(() => {
                    this.$refs.input.value = obj.keyword;
                    this.search();
                }, 100);
            }
        });

        EventBus.$off('search.close');
        EventBus.$on('search.close', () => {
            this.close();
        });
 
    },

}
</script>

<style lang="scss">
    html body.hide-scrollbar {
        overflow: hidden;
    }
    .search-wrap {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: var(--yellow);
        z-index: 99999999999;


        & > .inner {
            display: grid;
            grid-template-rows: auto  auto 1fr;
            grid-template-columns: 100%;
            height: 100%;
        }

        .search-input {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: var(--padding-50) var(--padding);

            span {
                position: relative;
                display: block;
                font-size: var(--title-size);
                cursor: pointer;
            }

            input {
                flex: 1;
                // margin: 0 var(--padding);
                padding: 0 var(--padding-50);
                box-sizing: border-box;
                background: none;
                border: none;
                font-size: var(--large-size);
                line-height: 1;

                &::placeholder {
                    color: var(--font-color);
                }
            }
        }

        .loading-wrap.static {
            padding: 20rem 0;

            .lds-spinner {
                margin: 0 auto;
                padding: var(--padding-x2);
            }
        }

        .loading-wrap.static .lds-spinner div:after {
            background: #fff;
        }
        
        .close {
            position: absolute;
            padding: 0;
            top: 0;
            right: var(--padding);
            cursor: pointer;
            font-size: var(--padding-x2);
        }
        

        .search-header {
            padding:  var(--padding-50) var(--padding);

            .top {
                display: flex;
                // padding: 0 0 var(--padding) 0;
         

                span {
                    flex: 1;
                }
            }

            // ul {
            //     display: flex;

            //     li {
            //         padding-right: var(--padding);
            //     }

            //     span {
            //         cursor: pointer;
            //     }
            // }
        }
 

        .search-box {
            overflow: auto;


            .item {
                a {
                    display: block;
                    padding: 1rem var(--padding);
                    background: var(--gray);
                }









                &:nth-child(1n+0) a {
                    background: var(--gray);
                }

                &:nth-child(2n+0) a {
                    background: var(--orange);
                }

                &:nth-child(3n+0) a {
                    background: var(--signal-green);
                }

                &:nth-child(4n+0) a {
                    background: var(--sand);
                }

                &:nth-child(5n+0) a {
                    background: var(--red);
                }

                &:nth-child(6n+0) a {
                    background: var(--blue);
                }

                &:nth-child(7n+0) a {
                    background: var(--green);
                }

                &:nth-child(8n+0) a {
                    background: var(--cloud-blue);
                }

                &:nth-child(9n+0) a {
                    background: var(--light-gray);
                }
            }

            // --light-gray: #E9E9E9;
            // --dark-gray: #9A9A9A;

            // --signal-green: #256e3a;
            // --sand: #ffe9be;
            // --red: #8c2c31;
            // --orange: #ff5032;
            // --gray: #868889;
            // --green: #a4c080;
            // --blue: #0079c5;
            // --yellow: rgb(255,230,0);
            // --cloud-blue: #adc5cb;
        }

        .list-item {

            // padding: 0;
            // display: flex;//#FFC700
            // flex-wrap: wrap;
            // line-height: 1.2;

            // dt,
            // dd {
            //     padding-right: var(--padding-50);
            //     font-size: var(--medium-size);
            // }



            // dd:last-child::after {
            //     display: none;
            // }
        }
    }

    @media only screen and (max-width: 767px) {
    
    }


</style>
